import React, { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import BodyText from "../../elements/body-text";
import PrimaryButton from "../../elements/primary-button";
import { getOrderType, presalesOrderDetails } from "../../utils/processesOrderDetails";
import { S_MEMBERCREATE_CONTRACTID, webStorage } from "../../utils/webStorage";
import api from "../../utils/api";
import { memberCreate } from "../../services/member";
import { selectUserState } from "../../selectors/application";
import { LOGOUT, setUserInfoAction } from "../../redux/actions";
import Heading from "../../elements/heading";
import AccountOverviewForm from "../form-overview-section";
import { getUserInfo } from "../../services/userService";
import { printPdf } from "../../utils/lynkco-constants";
import "./style.scss";

const PreSalesInStoreOrderConfirmation = ({ lang, fields, history, orderId, user, setUserInfo, summaryCommons, logout }) => {
  const { headingType, headingBody, body, labels, level0Label, level12Label, digitalReceiptHeading, digitalReceiptBody, printReceiptHeading, printReceiptBody, printButton } = fields;
  const pdfIframeRef = useRef(null);
  const [payUrl, setPayUrl] = useState(null);
  const [orderData, setOrderData] = useState([]);
  const [orderDetail, setOrderDetail] = useState(null);
  const [heading, setHeading] = useState({
    type: headingType,
    html: JSON.parse(JSON.stringify(headingBody))
  });
  let unloadStatus = false;

  useEffect(() => {
    // get order data from API
    // here faked with fakeOrderData
    getData();
    return () => {
      unloadStatus = true;
    };
  }, []);
  useEffect(() => {}, [orderDetail]);

  const getData = async () => {
    // 967 618027419391102976
    if (!summaryCommons) return;
    const { membershipCode } = summaryCommons;
    if (membershipCode === "MEMBERSHIP04") {
      level3Date();
    } else {
      getLabel();
      changeUserLevel();
    }
    return () => {
      unloadStatus = true;
    };
  };

  const setCountryLang = async () => {
    if (lang?.toLocaleLowerCase() === "en") {
      user.membershipCode = summaryCommons?.membershipCode;
      setUserInfo(user);
      return null;
    }
    let countryLang = null;
    try {
      countryLang = await api.site.get(null, { key: lang });
      await api.user.countrylang.update(null, {
        preferredCountry: countryLang?.CountryLocal,
        preferredLanguage: countryLang?.CountryLang,
        userAccount: user.userAccount
      });
      const newUser = await getUserInfo();
      setUserInfo(newUser);
    } catch (err) {
      console.dir(err);
    }
  }
  const changeUserLevel = async evt => {
    const contractId = webStorage.get(S_MEMBERCREATE_CONTRACTID) || "";
    if (user && summaryCommons?.membershipCode && user.membershipCode !== summaryCommons.membershipCode && ["MEMBERSHIP01", "MEMBERSHIP02", "MEMBERSHIP03"].includes(user.membershipCode)) {
      try {
        await api.user.membership.update(null, {
          userAccount: user.userAccount,
          membershipLevel: summaryCommons?.membershipCode
        });
        if (contractId) {
          memberCreate({
            contractId: contractId,
            surname: user.lastName,
            firstName: user.firstName,
            emailAddress: user.email,
            isEmailOptout: user.subscribed,
            membership: user.membershipCode
          }).then(() => {
            webStorage.clear(S_MEMBERCREATE_CONTRACTID);
          });
        }
        await setCountryLang();
      } catch (ex) {
        // setSubmitError(true);
      }
    }

    /*
    contiue to next step ...
    level 0-2 update mmebship to backend
    level 3 contiune to become a member flow and checkout.
    */

    // if request fail setSubmitError(true)

    // on success close modal
  };
  const getLabel = () => {
    let currentLevelList = [],
      labelResultList = [];
    const membershipCode = summaryCommons ? summaryCommons.membershipCode : "";

    if (membershipCode === "MEMBERSHIP01") {
      currentLevelList = level0Label;
    } else if (membershipCode === "MEMBERSHIP02" || membershipCode === "MEMBERSHIP03") {
      currentLevelList = level12Label;
    }
    (currentLevelList || []).forEach((item, index) => {
      let labelKey = (item && item.fields && item.fields.key.value) || "";
      let labelValue = "";
      switch (labelKey) {
        case "orgName":
          labelValue = summaryCommons.country;
          break;
        case "memberShip":
          labelValue = summaryCommons.membership;
          break;
        case "color":
          labelValue = summaryCommons.color?.preSelectValue?.value;
          break;
        case "engine":
          labelValue = summaryCommons.engine?.preSelectValue?.value;
          break;
        case "customerNumber":
          labelValue = summaryCommons.customerNumber || user?.customerNumber;
          break;
        case "orderDeposit":
          labelValue = summaryCommons.formattedPrice;
          break;
        default:
      }
      labelResultList.push({
        label: item.fields.phrase.value,
        value: labelValue
      });
    });
    if (!unloadStatus) {
      setOrderData(labelResultList);
    }
  };
  const level3Date = async () => {
    //"114" "8AD21CA75821000"
    let node = document.createElement("div");
    node.innerHTML = headingBody ? headingBody.value : "";
    const { orderDetail, orderData } = await presalesOrderDetails({
      orderId: orderId,
      membership: summaryCommons?.membership,
      labels: labels,
      lang: lang,
      inStore: true
    });
    if (node.firstChild) {
      node.firstChild.innerText += " " + orderDetail?.orderNo;
      heading.html.value = node.innerHTML;
      setHeading(heading);
    }
    let _orderType = getOrderType(orderDetail?.subType);
    if (_orderType === "gears") {
      _orderType = printPdf.gearConfirm;
    }
    if (_orderType === "presale") {
      _orderType = printPdf.preSaleConfirm;
    }
    logout();
    setPayUrl(`/${lang}/PdfView?type=${_orderType}&pageFormat=A5&orderNo=${orderDetail?.orderNo}`);
    setOrderData(orderData);
    setOrderDetail(orderDetail);
  };

  const printReceipt = () => {
    pdfIframeRef.current.contentWindow.print();
    // console.log("Print receipt button click");
  };
  const replacePlaceholder = (str, findStr, replaceStr) => {
    let newArr = str.split(findStr);
    let newStr = newArr.join(replaceStr);
    return newStr;
  };
  let ReceiptBody = digitalReceiptBody?.value ? `${digitalReceiptBody?.value} <span style="color: #1ef1c6;">${orderDetail?.billingInfo?.email || ""}</span>` : "";
  ReceiptBody = replacePlaceholder(ReceiptBody, "${orderConfirmation}", orderDetail?.orderNo);
  // ReceiptBody = replacePlaceholder(ReceiptBody,"${receipt}", orderDetail?.orderNo);
  console.log(summaryCommons);
  return (
    <>
      {summaryCommons?.membershipCode !== "MEMBERSHIP04" && (
        <>
          <AccountOverviewForm heading={heading} items={orderData} />
        </>
      )}
      {summaryCommons?.membershipCode === "MEMBERSHIP04" && (
        <>
          <Heading
            className="title"
            {...{
              ...heading,
              typographyClass: "type-h3"
            }}
          />
          <div className="pre-sales-in-store-order-confirmation grid">
            <div className="receipt-digital">
              <h3 className="type-h3">
                <span>
                  {digitalReceiptHeading.value} {orderDetail?.orderNo}
                </span>
              </h3>
              <BodyText html={ReceiptBody} />
            </div>
            <div className="receipt-printed">
              <h3 className="type-h3">{printReceiptHeading.value}</h3>
              <BodyText html={printReceiptBody.value} />
              <PrimaryButton
                {...{
                  colorScheme: printButton?.fields.colorScheme,
                  iconName: printButton?.fields.iconName,
                  link: {
                    value: {
                      text: printButton?.fields.buttonText.value
                    }
                  },
                  callback: evt => printReceipt(evt)
                }}
              />
            </div>
            <iframe ref={pdfIframeRef} style={{ display: "none" }} src={payUrl} />
          </div>
        </>
      )}
      <BodyText html={body.value} className="message" />
    </>
  );
};

PreSalesInStoreOrderConfirmation.propTypes = {
  orderDetail: PropTypes.object,
  digitalReceiptHeading: PropTypes.object,
  digitalReceiptBody: PropTypes.object,
  printReceiptHeading: PropTypes.object,
  printReceiptBody: PropTypes.object,
  printButto: PropTypes.object
};
const mapStateToProps = state => ({
  user: selectUserState(state),
  summaryCommons: state.becomeAMemberSummary
});
const mapDispatchToProps = dispatch => ({
  setUserInfo: data => dispatch(setUserInfoAction(data)),
  logout: (...args) => dispatch({ type: LOGOUT, ...args })
});
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PreSalesInStoreOrderConfirmation));
